import { render, staticRenderFns } from "./AgileAuditTag.vue?vue&type=template&id=339217c0&scoped=true&"
import script from "./AgileAuditTag.vue?vue&type=script&lang=ts&"
export * from "./AgileAuditTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339217c0",
  null
  
)

export default component.exports